
<a (click)="logout()" class="btn btn-default btn-flat float-right">
    Salir
</a>
<a (click)="openChangePasswordDialog()" id="cambiar-contrasenia-btn" class="btn btn-default btn-flat float-right">
    Cambiar contraseña
</a>
